<script>
import StringUtils from '@/utils/stringUtils'
import VueUtils from '@/utils/vueUtils'

export default
{
    name: 'wide-icon-tile',

    props: ['id', 'title', 'subtitle', 'icon', 'inlineSvg', 'rightContent', 'pictures', 'disabled'],

    render () 
    { 
        return (
            <div id={this.id} class={`wide-icon-tile ${this.disabled ? 'disabled': ''}`} on-click={this.onClick}>
                <div class='header'>
                    {
                        this.icon && this.inlineSvg ?
                        (
                            <inline-svg skip-embedded-size={true} class='icon' src={this.icon} />
                        ) :
                        (
                            typeof this.icon == 'string'
                                ? <img class='icon' src={this.icon} />
                                : <div class='icon vnode' v-show={this.icon}>{this.icon}</div>
                        )
                    }
                    <div class='middle'>
                        <span class='title'>{ this.title }</span>
                        { 
                            VueUtils.isVNode(this.subtitle)
                                ? <span class ='subtitle'>{this.subtitle}</span>
                                : !StringUtils.isEmptyString(this.subtitle) &&  <span class='subtitle' domPropsInnerHTML={this.subtitle} />
                        }
                    </div>

                    <div class='right'>
                        { this.rightContent == undefined && this.$listeners.click && <inline-svg class='goto-arrow' src={require('@/assets/img/back-thick.svg')} /> }
                        { this.rightContent }
                    </div>
                </div>

                {
                    this.pictures && this.pictures.length > 0 &&
                    <div class='picture'>
                        <img src={this.pictures[0]} />
                    </div>
                }

                <div class='slot'>{this.$slots.default}</div>
            </div>
        )
    },

    data () 
    {
        return {
        }
    },

    mounted ()
    {
        if (this.$listeners.click) this.$el.classList.add('clickable')
    },

    methods:
    {
        onClick ()
        {
            if (this.disabled)
            {
                this.$emit('click-disabled')
            }
            else this.$emit('click')
        }
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.wide-icon-tile
{
    padding: 15px 20px;
    border-radius: 5px;
    box-shadow: var(--theme-box-shadow-sharp);
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 8px;
    background-color: var(--theme-content-background-color);
    transition: background-color 0.1s ease-in-out;

    &.disabled
    {
        background-color: var(--theme-border-color-light);
        box-shadow: none;
    }

    &.clickable
    {
        cursor: pointer;

        &:hover
        {
            background-color: var(--theme-border-color-mega-light);
        }
    }

    .header
    {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;

        > .icon
        {
            margin-right: 20px;
            width: 50px;
            height: 50px;
            border-radius: 6px;
            fill: var(--theme-background-text-color);

            &.vnode
            {
                > *
                {
                    width: inherit;
                    height: inherit;
                }
            }
        }

        > .middle
        {
            display: flex;
            flex-direction: column;
            width: 100%;

            > .title
            {
                font-size: 100%;
                font-weight: 600;
                color: var(--theme-text-color-lighter);

                .CapitalizeFirstLetter();
            }

            > .subtitle
            {
                font-size: 80%;
                margin-top: 5px;
                color: var(--theme-text-color-extra-light);

                .CapitalizeFirstLetter();
            }
        }

        > .right
        {
            width: 15%;
            margin-left: auto;
            text-align: right;
            font-size: 90%;

            & .goto-arrow
            {
                width: 13px;
                transform: rotate(180deg);
                fill: var(--theme-background-text-color-heavy);
            }
        }
    }

    .picture
    {
        width: 100%;
        margin-top: 10px;

        img
        {
            width: 100%;
            border-radius: 4px;
        }
    }

    .slot
    {
        width: 100%;
        margin-top: 5px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/WideIconTile.vue